import { useEffect, useRef, useState } from "react";
import countries from "../../constants/countries.json";
import { ArrowIcon } from "../Icons";

interface Props {
  value: string;
  onChange: (val: string) => void;
}

export default function CountryDialCodeSelect({ value, onChange }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const selected = countries.find((c) => c.dialCode === value) || countries[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      {/* Selected button */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 border-[0.66px] border-[#d0d5dd] px-3 py-[10px] rounded-[8px] w-full bg-white"
      >
        <img
          src={selected.flag}
          alt={selected.name}
          className="w-5 h-5 rounded-sm"
        />
        <span className="text-sm">{selected.dialCode}</span>
        <span className="ml-auto">
          <ArrowIcon className="size-[10px]" />
        </span>
      </button>

      {/* Dropdown list */}
      {open && (
        <ul className="absolute z-10 mt-1 max-h-60 max-w-60 w-max overflow-y-auto border rounded-md bg-white shadow-lg">
          {countries.map((c) => (
            <li
              key={c.iso2}
              onClick={() => {
                onChange(c.dialCode);
                setOpen(false);
              }}
              className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 cursor-pointer"
            >
              <img src={c.flag} alt={c.name} className="w-5 h-5 rounded-sm" />
              <span>{c.name}</span>
              <span className="ml-auto text-gray-500">{c.dialCode}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
